import {useCallback,useLayoutEffect,useRef,useState} from 'react';

const readPreference=(key,initialValue)=>{
  if (!key || typeof window==='undefined') return initialValue;

  try {
    const stored=window.localStorage.getItem(key);
    if (stored===null) return initialValue;

    const value=JSON.parse(stored);
    if (initialValue===null) {
      return value===null || typeof value==='string'
        ? value
        : initialValue;
    }

    return typeof value===typeof initialValue
      ? value
      : initialValue;
  } catch {
    return initialValue;
  }
};

export default function useUserPreference(userId,name,initialValue) {
  const storageKey=userId
    ? `sohlocal:ui:${name}:${userId}`
    : null;

  const [stored,setStored]=useState(()=>({
    storageKey,
    value:readPreference(storageKey,initialValue)
  }));
  const latestStored=useRef(stored);

  if (stored.storageKey===storageKey) {
    latestStored.current=stored;
  }

  useLayoutEffect(()=>{
    const nextStored={
      storageKey,
      value:readPreference(storageKey,initialValue)
    };

    latestStored.current=nextStored;
    setStored(nextStored);
  },[storageKey,initialValue]);

  useLayoutEffect(()=>{
    if (
      !storageKey
      || stored.storageKey!==storageKey
      || typeof window==='undefined'
    ) {
      return;
    }

    try {
      window.localStorage.setItem(
        storageKey,
        JSON.stringify(stored.value)
      );
    } catch {
      // Keep the current page usable if browser storage is unavailable.
    }
  },[storageKey,stored]);

  const setValue=useCallback((nextValue)=>{
    const current=latestStored.current;
    const currentValue=current.storageKey===storageKey
      ? current.value
      : initialValue;
    const nextStored={
      storageKey,
      value:typeof nextValue==='function'
        ? nextValue(currentValue)
        : nextValue
    };

    latestStored.current=nextStored;

    if (storageKey && typeof window!=='undefined') {
      try {
        window.localStorage.setItem(
          storageKey,
          JSON.stringify(nextStored.value)
        );
      } catch {
        // Keep the current page usable if browser storage is unavailable.
      }
    }

    setStored(nextStored);
  },[storageKey,initialValue]);

  return [
    stored.storageKey===storageKey ? stored.value : initialValue,
    setValue
  ];
}
